// Theme service for managing light/dark mode across the application
import { ref, watch } from 'vue'

// Create a reactive theme state
const isDark = ref(false)

// Initialize theme based on localStorage or system preference
const initTheme = (): void => {
  const savedTheme = localStorage.getItem('theme')
  if (
    savedTheme === 'dark' ||
    (!savedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches)
  ) {
    isDark.value = true
    document.documentElement.classList.add('dark')
  } else {
    isDark.value = false
    document.documentElement.classList.remove('dark')
  }
}

// Toggle between light and dark theme
const toggleTheme = (): void => {
  isDark.value = !isDark.value
  updateTheme()
}

// Update theme based on current isDark value
const updateTheme = (): void => {
  if (isDark.value) {
    document.documentElement.classList.add('dark')
    localStorage.setItem('theme', 'dark')
  } else {
    document.documentElement.classList.remove('dark')
    localStorage.setItem('theme', 'light')
  }
}

// Watch for theme changes and update accordingly
watch(isDark, () => {
  updateTheme()
})

export default {
  isDark,
  initTheme,
  toggleTheme
}
